import { createFileRoute } from "@tanstack/react-router";

import { NotificationsListPerUser } from "@/components/Notifications/userList/component.tsx";
import {
  useBreadCrumbItems,
  useNotificationTableData,
} from "@/components/Notifications/userList/hooks.tsx";

const UserNotificationsView = () => {
  // eslint-disable-next-line no-use-before-define
  const { id } = Route.useParams();

  return (
    <NotificationsListPerUser
      id={id}
      useBreadCrumbItems={useBreadCrumbItems}
      useNotificationTableData={useNotificationTableData}
    />
  );
};

export const Route = createFileRoute("/users/$id/notifications/")({
  component: UserNotificationsView,
});
